import React from 'react';
import StockMarketRules from '../shared/StockMarketRules';
import BackToRulesLink from './BackToRulesLink';
import PublicRulesLayout from './PublicRulesLayout';

export default function StockMarketRulesPage() {
  return (
    <PublicRulesLayout>
      <StockMarketRules title="Stock Market League Rules" headerAction={<BackToRulesLink />} />
    </PublicRulesLayout>
  );
}
